import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/safiruni/front/app/[lang]/(ADMIN)/dashboard/_sideBar/Block/Sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileSidebar"] */ "/var/www/safiruni/front/app/[lang]/(ADMIN)/dashboard/_sideBar/MobileSidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/safiruni/front/components/shared/common/LangSwitcher/LangSwitcherClient.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/safiruni/front/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/safiruni/front/node_modules/next/font/google/target.css?{\"path\":\"app/[lang]/(ADMIN)/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/var/www/safiruni/front/public/icons/Global.svg");
